import Swiper, { Scrollbar } from 'swiper';
import 'swiper/css';

export default class ProductIngredientsCarousel {
    constructor(element) {
        if (!element) return;

        this.element = element;
        this.context = this.element.closest('.js-pdp-ingredients-carousel-context');
        this.scrollbarElement = this.context.querySelector('.js-pdp-ingredients-carousel-scrollbar')

        this.init();
    }

    init() {
        new Swiper(this.element, {
            modules: [Scrollbar],
            slidesPerView: 'auto',
            centerInsufficientSlides: true,
            spaceBetween: 20,
            threshold: 10,
            scrollbar: {
                el: this.scrollbarElement,
                draggable: true
            },
            breakpoints: {
                1024: {
                    slidesPerView: 5,
                    spaceBetween: 60
                }
            }
        });
    }
}
